
<app-header [isUserLoggedIn]="isLoggedIn"></app-header>
<main class="page-content">
	<router-outlet></router-outlet>
</main>